import { css } from '@emotion/react';
import { Modal } from 'antd';
import { useState } from 'react';

import type { ModalProps } from 'antd';
import type { ReactNode } from 'react';

export interface BaseDialogProps extends ModalProps {
  title?: string;
  width?: number;
  footer?: ReactNode;
}

function BaseDialog({ children, title, width, footer: _footer, ...props }: BaseDialogProps) {
  const [isAnimating, setIsAnimating] = useState(false);

  const handelMaskClick = () => {
    setIsAnimating(true);
    setTimeout(() => {
      setIsAnimating(false);
    }, 100);
  };

  return (
    <Modal
      title={title}
      closable={false}
      css={[isAnimating && styles.dialogAnimated]}
      maskClosable={false}
      // footer={null}
      width={width}
      open
      onCancel={handelMaskClick}
      {...props}
    >
      <div>{children}</div>
    </Modal>
  );
}

const styles = {
  dialog: css`
    .ant-modal-content {
    }
  `,

  dialogAnimated: css`
    .ant-modal-content {
      -webkit-animation-duration: 0.15s;
      animation-duration: 0.15s;
      -webkit-animation-name: animate-dialog-not-closable;
      animation-name: animate-dialog-not-closable;
      -webkit-animation-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
      animation-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
    }

    @keyframes animate-dialog-not-closable {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.025);
      }
      100% {
        transform: scale(1);
      }
    }
  `,
};

export default BaseDialog;
